import React from 'react'
import { useTranslation } from 'react-i18next'

export function useEnumTranslation() {
  const { t, i18n } = useTranslation()

  const te = React.useCallback(
    (name: string, value: string): string => {
      const enumKey = `Enum.${name}`
      const options = { context: value }

      const fallbackValue = value ?? ''
      return i18n.exists(enumKey, options) ? t(enumKey, options) : fallbackValue
    },
    [t, i18n.language]
  )

  const tes = React.useCallback(
    (name: string, values: string[]): string => {
      const enumKey = `Enum.${name.replace('SliceOfEnum', 'Enum')}`

      return values
        .reduce<string[]>((result, context) => {
          const options = { context }

          if (i18n.exists(enumKey, options)) result.push(t(enumKey, options))

          return result
        }, [])
        .join(', ')
    },
    [t, i18n.language]
  )

  return {
    te,
    tes
  }
}
